<template>
    <others>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table
                :searchable="true"
                :fields="fields"
                :items="resources"
                :action="{'text':'Add Resource','url':route('others.resource.create')}"
                :searchlink="route('others.resource.search')"
                :canView="isAdmin()"
                :canCreate="isAdmin()"
            >
                <template #title="data">
                    <div class="font-medium">{{ data.item.title }}</div>
                    <div class="max-w-xl text-gray-500 whitespace-normal" v-if="data.item.description">
                        {{ data.item.description }}
                    </div>
                </template>
                <template #due_date="data">
                    {{ formatDate(data.item.due_date) }}
                </template>
                <template #status="data">
                    {{ data.item.status ? 'Active' : 'Inactive' }}
                </template>
                <template #progress="data">
                    {{ data.item.accepted_submissions_count }} accepted / {{ data.item.submissions_count }} branches
                    <div class="text-xs text-gray-500">
                        {{ data.item.pending_review_submissions_count }} pending review,
                        {{ data.item.declined_submissions_count }} declined
                    </div>
                </template>
                <template #action="data">
                    <button-link :href="route('others.resource.view', data.item.id)" :class="'mr-2'">View</button-link>
                    <button-link :href="route('others.resource.edit', data.item.id)">Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </others>
</template>

<script>
import Others from '@/Pages/Others/Others'
import ButtonLink from '@/Components/ButtonLink'
import BreezeTable from '@/Components/Table'

export default {
    components: {
        Others,
        ButtonLink,
        BreezeTable,
    },
    props: ['resources'],
    data() {
        return {
            fields: [
                {'key': 'title', 'label': 'Resource'},
                {'key': 'due_date', 'label': 'Due Date'},
                {'key': 'status', 'label': 'Status'},
                {'key': 'progress', 'label': 'Branch Progress'},
                {'key': 'action', 'label': 'Action'},
            ],
        }
    },
    methods: {
        formatDate(date) {
            return date ? date.substring(0, 10) : '-';
        },
        isAdmin() {
            const role = this.$page.props.auth.user.role;

            return role?.type === 'super' || role?.name === 'Super Admin';
        },
    },
}
</script>
